<router-outlet></router-outlet>
<loading-indicator class="overlay" [isVisible]="loading$ | async"></loading-indicator>